"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var isCordova = function isCordova() {
  return typeof window != "undefined" && (typeof window.PhoneGap != "undefined" || typeof window.Cordova != "undefined" || typeof window.cordova != "undefined");
};

exports.default = isCordova;


//////////////////
// WEBPACK FOOTER
// ./node_modules/tus-js-client/lib.es5/browser/isCordova.js
// module id = He+T
// module chunks = 1